import { Component } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
// import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import './App.css'
import Routes from './Routes'
import Fallback from 'components/Fallback/Fallback'
import FullscreenProvider from 'providers/Fullscreen/Provider'
import { SnackbarProvider } from 'notistack'
import ThemeModeProvider from 'theme/ThemeModeProvider'

import Layout from './containers/Layout/Layout'
import { store } from './redux/store'

export const queryClient = new QueryClient()

// const persister = createSyncStoragePersister({
//   storage: window.localStorage,
// })

class AppWrap extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error boundary: ', error, errorInfo)
  }

  render() {
    // ThemeModeProvider is the OUTERMOST provider on purpose: it renders MUI's ThemeProvider
    // + CssBaseline, and everything that can put pixels on screen has to sit inside it —
    // including notistack's toast portal, the react-query devtools panel and the error
    // boundary's own fallback, all of which used to render on an unthemed page.
    return (
      <ThemeModeProvider>
        {this.state.hasError ? (
          <Fallback
            themed={false}
            title='Something went wrong'
            detail='The console hit an unrecoverable error. Reloading usually clears it; if it does not, the details are in the browser console.'
            actionLabel='Reload'
            onAction={() => window.location.reload()}
          />
        ) : (
          <QueryClientProvider client={queryClient}>
            <SnackbarProvider maxSnack={5}>
              <BrowserRouter>
                <Provider store={store}>
                  <FullscreenProvider>
                    <Layout>
                      <Routes />
                    </Layout>
                  </FullscreenProvider>
                </Provider>
              </BrowserRouter>
            </SnackbarProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        )}
      </ThemeModeProvider>
    )
  }
}

export default AppWrap
